import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function PrivateRoute() {
  const { authPayload } = useAuth();

  if (!authPayload?.id_token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
